import * as tslib_1 from "tslib";
import { getNow } from '../utils/getNow';
import { getFallbackValueIfNull } from 'owa-options-core';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
import { lazyUserInitiatedWebPushSetupWorkflow, lazyUserInitiatedWebPushDisableWorkflow, getLocalWebPushUserSettingStore, logEnableStart, logDisableStart, logWorkFlowEnd, } from 'owa-webpush-notifications';
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
var saveWebPushNotificationsOptions = select({
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.WebPushNotifications);
    },
    localWebPushUserSetting: function () { return getLocalWebPushUserSettingStore(); },
    windowObj: function () { return window; },
})(action('saveWebPushNotificationsOptions')(function saveWebPushNotificationsOptions(isEnabledOnMachineOverride, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, localWebPushUserSetting, windowObj, mbxGuid, userInitiatedWebPushSetupWorkflow, enabled, userInitiatedWebPushDisableWorkflow, disabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, localWebPushUserSetting = state.localWebPushUserSetting, windowObj = state.windowObj;
                    if (userOptions.applicationServerKey == null) {
                        return [2 /*return*/];
                    }
                    localWebPushUserSetting.enabled = getFallbackValueIfNull(isEnabledOnMachineOverride, localWebPushUserSetting.enabled);
                    if (!!userOptions.enabled) return [3 /*break*/, 2];
                    // If it is yet not enabled, then it might be a request to enable for first time, update the server state to enabled as well.
                    userOptions.enabled = getFallbackValueIfNull(isEnabledOnMachineOverride, userOptions.enabled);
                    userOptions.enabledTimeInUTCMs = getNow().toString();
                    return [4 /*yield*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.WebPushNotifications, userOptions)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    mbxGuid = getUserConfiguration().SessionSettings.MailboxGuid;
                    if (!(userOptions.enabled && localWebPushUserSetting.enabled)) return [3 /*break*/, 5];
                    return [4 /*yield*/, lazyUserInitiatedWebPushSetupWorkflow.import()];
                case 3:
                    userInitiatedWebPushSetupWorkflow = _a.sent();
                    logEnableStart('settings');
                    return [4 /*yield*/, userInitiatedWebPushSetupWorkflow(windowObj, userOptions, mbxGuid)];
                case 4:
                    enabled = _a.sent();
                    logWorkFlowEnd(enabled);
                    return [3 /*break*/, 8];
                case 5: return [4 /*yield*/, lazyUserInitiatedWebPushDisableWorkflow.import()];
                case 6:
                    userInitiatedWebPushDisableWorkflow = _a.sent();
                    logDisableStart('settings', false);
                    return [4 /*yield*/, userInitiatedWebPushDisableWorkflow(windowObj, userOptions, mbxGuid, false)];
                case 7:
                    disabled = _a.sent();
                    logWorkFlowEnd(disabled);
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}));
export default saveWebPushNotificationsOptions;
export function saveWebPushNotificationsOptionsQuick(isEnabledOnMachine) {
    saveWebPushNotificationsOptions(isEnabledOnMachine);
}
//# sourceMappingURL=saveWebPushNotificationsOptions.js.map